// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actionContainer{float:left;width:100%}.main-grid{float:left;width:100%}.info{text-align:start;float:left;width:100%}\n", ""]);
// Exports
module.exports = exports;
